import { FC } from 'react';
import { Box } from '@chakra-ui/react';

import Heading from 'components/_core/Heading';
import Timeline from 'components/_core/Timeline';

interface InsuranceTimelineProps {
  title: string;
  steps: readonly string[];
}

const InsuranceTimeline: FC<InsuranceTimelineProps> = ({ steps, title }) => {
  return (
    <Box>
      <Heading paddingBottom="space-16">{title}</Heading>

      <Timeline>
        {steps.map((text) => (
          <Timeline.Step key={text}>{text}</Timeline.Step>
        ))}
      </Timeline>
    </Box>
  );
};

export default InsuranceTimeline;
